import { defineStore } from "pinia";
import { defHttp } from "@utils/http";
import { isLoggedIn } from "@utils/user";
import { ref } from "vue";
import modelManager from "@/utils/modelManager";

export const useShopStore = defineStore("shoppingList", {
  state: () => {
    return {
      apiHadrDiskSize: 0, // api硬盘容量
      localHadrDiskSize: 0, // 本地硬盘容量
      hardDiskSize: {
        value: 0,
        Type: Number,
      }, // 总硬盘容量 不能超过500M
      shoppingCartListTotal: 0, // 购物车总价
      shoppingCartList: [], // 购物车列表
      isLoading: false, // 加载中
    };
  },
  getters: {},
  actions: {
    clearShoppingState() {
      this.apiHadrDiskSize = 0;
      this.localHadrDiskSize = 0;
      this.hardDiskSize = 0;
      this.shoppingCartListTotal = 0;
      this.shoppingCartList = [];
      this.isLoading = false;
    },
    async getShoppingList() {
      if (!isLoggedIn()) {
        this.clearShoppingState();
        return;
      }
      this.isLoading = true;
      const dataAll = await (
        await defHttp.post("/api/user-api/basket/listV2", { laterPrint: 0 })
      ).data.data;
      this.shoppingCartListTotal = dataAll.totalPrice;
      const data = dataAll.list;
      this.apiHadrDiskSize = dataAll.totalFileSize;
      console.log("获取到api硬盘容量", this.apiHadrDiskSize);
      if (data) {
        this.shoppingCartList.splice(0);
        data.forEach((item) => {
          console.log(111, data, item);
          const num = ref(item.basketCount);
          const good = {
            id: item.basketId,
            prodId: item.prodId,
            num: ref(num),
            img: item.pic,
            price: item.price,
            children: undefined,
            skuList: item.items,
            state: item.state, // 0=自定义打印，其它=普通商品，用于跳转判断
            items: item.items, // 原始sku列表，自定义打印回填需要
          };
          console.log(222, good, this.shoppingCartList);
          this.shoppingCartList.push(good);
        });
      }
      console.log("购物车列表", this.shoppingCartList);
      this.isLoading = false;
    },
    async getLocalHadrDiskSize() {
      this.isLoading = true;
      const indexDBSize = await modelManager.getIndexDBSize();
      this.localHadrDiskSize = Number(indexDBSize);
      console.log("localHadrDiskSize", this.localHadrDiskSize);
      this.hardDiskSize =
        (this.apiHadrDiskSize + this.localHadrDiskSize).toFixed(1) < 0.1 &&
        this.apiHadrDiskSize + this.localHadrDiskSize > 0
          ? 0.1
          : (this.apiHadrDiskSize + this.localHadrDiskSize).toFixed(1);
      this.isLoading = false;
    },
    getHardDiskSize() {
      console.log("getHardDiskSize", this.localHadrDiskSize);
      this.hardDiskSize =
        (this.apiHadrDiskSize + this.localHadrDiskSize).toFixed(1) < 0.1 &&
        this.apiHadrDiskSize + this.localHadrDiskSize > 0
          ? 0.1
          : (this.apiHadrDiskSize + this.localHadrDiskSize).toFixed(1);
    },
    async init() {
      await this.getShoppingList();
      await this.getLocalHadrDiskSize();
    },
  },
});
